import { useRef } from "react";

import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material";

import { isExternalCoverageActive } from "@covertree/utils";
import { mapCoverageStatus } from "@utils";
import { Tooltip } from "@covertree/ui/content";

interface PolicyStatusInfoProps {
  policyEffectiveDate: Date;
  policyEndDate: Date;
  tooltip: string;
}

export function PolicyStatusInfo({
  policyEffectiveDate,
  policyEndDate,
  tooltip,
}: PolicyStatusInfoProps) {
  const theme = useTheme();
  const labelRef = useRef<HTMLParagraphElement>(null);
  const isDesktop = useMediaQuery(theme.breakpoints.up("xl"));

  return (
    <Typography variant="body2" ref={labelRef} width={250}>
      Policy Status:{" "}
      <Typography component="span" color="secondary.main">
        {mapCoverageStatus(
          isExternalCoverageActive(policyEffectiveDate, policyEndDate)
        )}
      </Typography>
      {tooltip && (
        <Tooltip
          dataTestId="policy-status-info-tooltip"
          tooltip={tooltip ?? ""}
          size="large"
          sx={{ marginLeft: theme.spacing() }}
          placement={isDesktop ? "right" : "bottom"}
        />
      )}
    </Typography>
  );
}

export default PolicyStatusInfo;
